import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

import { StockInventorySummaryDto } from './type/StockInventorySummaryDto';

const ENDPOINT = `${APIConfiguration.sparePart}stockInventory/bySeller/${COMMON_QUERY_PARAMS.SELLER_ID}`;

export interface GetStockInventoryBySellerIdArgs {
  sellerId: string;
  page?: number;
  pageSize?: number;
  filters?: SearchFilterFacet[];
  sortOptions?: SortOption[];
}

export default async function getStockInventoryBySellerId(
  payload: GetStockInventoryBySellerIdArgs,
): Promise<
  BackResponse<SearchResultList<StockInventorySummaryDto>> | BackResponseFailure
> {
  try {
    const URL = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.SELLER_ID,
      payload.sellerId,
    );

    return await apiCall<
      BackResponse<SearchResultList<StockInventorySummaryDto>>
    >(URL, {
      method: SUPPORTED_METHODS.POST,
      json: {
        page: payload.page ?? 1,
        pageSize: payload.pageSize ?? 25,
        filters: payload.filters ?? [],
        sortOptions: payload.sortOptions ?? [],
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
